import { elementEventFullName } from '@angular/compiler/src/view_compiler/view_compiler';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ChartOptions, ChartType } from 'chart.js';
import { Color, Label, SingleDataSet } from 'ng2-charts';
import { ReportingService } from 'src/app/services/reporting.service';

declare var require: any;

import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import * as Chart from 'chart.js';
import { Content, TDocumentDefinitions } from 'pdfmake/interfaces';
const htmlToPdfmake = require("html-to-pdfmake");
(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;

import jspdf, { TextOptionsLight } from 'jspdf';
import html2canvas from 'html2canvas';
import { resourceLimits } from 'worker_threads';
import autoTable, { Styles } from 'jspdf-autotable';
import { right } from '@popperjs/core';
import { NetworkService } from '../../../../services/network.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../../../../../environments/environment';
import { _ENDPOINT } from '../../../../endpoints/endpoint';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';










@Component({
  selector: 'app-overview-report',
  templateUrl: './overview-report.component.html',
  styleUrls: ['./overview-report.component.css']
})
export class OverviewReportComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() dropdownListBO: any[] = [];
  @Input() selectedItemsBO: any[] = [];
  @Input() dropdownListOrderCluster: any[] = [];
  @Input() selectedItemsOrderCluster: any[] = [];
  @Input() dropdownListCustomer: any[] = [];
  @Input() selectedItemsCustomer: any[] = [];
  @Input() dropdownListCountry: any[] = [];
  @Input() selectedItemsCountry: any[] = [];
  @Input() dropdownListMonth: any[] = [];
  @Input() selectedItemsMonth: any[] = [];
  @Input() dropdownListYear: any[] = [];
  @Input() selectedItemsYear: any[] = [];
  @Input() dropdownListOrderType: any[] = [];
  @Input() selectedItemsOrderType: any[] = [];
  @Input() customerOfCountry: Map<string, string[]>;
  @Input() orderTypeOfOrderCLuster: Map<string, string[]>;
  @Input() idLeadGlobalOfCustomerName: Map<string, string[]>;
  @Input() selectedItemsIdGlobal: any[] = [];

  @Input() dropdownListOrderStatus: any[] = [];
  @Input() selectedItemsOrderStatus: any[] = [];
  @Input() dropdownListLead: any[] = [];
  @Input() selectedItemsLead: any[] = [];

  @Output() loadReportEvent = new EventEmitter<any>();

  viewOrderStatus: boolean = true;

   pieChartDataEx: SingleDataSet = [1,1,1,100];

  public pieChartOptions: ChartOptions = {

    title: {
      text: 'Countries',
      display: true,
      position: 'top',
      fontSize: 18,
      fontStyle: 'bold',
      fontColor: "black"
    },
    legend: {
      position: 'top',
      labels: {
        fontColor: "black",
        fontSize: 18,
        fontStyle: 'bold',

      },
      onClick: (event, legendItem) => {
        event.stopPropagation();
      }
    },
    responsive: true,
    maintainAspectRatio: false,

    plugins: {
      title: {
        display: true,
        text: 'Countries',
        fontColor: 'black',
        position: 'top',
        fontSize: 18,
      },
      labels: {
        render: 'percentage',
        fontColor: 'black',
        fontSize: 18,
        position: 'outside',
        precision: '2',
        fontStyle: 'bold',
        textMargin: 10,
        outsidePadding: 8,
        overlap:false
      },
    }
  };
  @Input() pieChartLabels: Label[] = [];
  @Input() pieChartData: SingleDataSet = [];
  pieChartType: ChartType = 'doughnut';
  pieChartLegend = true;
  pieChartPlugins = [];

  @Input()
  orders: any[] = [];

  colors: Color[] = [
    {
      backgroundColor: [
        '#00D2AE', '#F8AFA6', '#FDB750', '#D4F1F4', '#D3F4FB', '#DFF1FF', '#C2FCF4', '#F2F1F0', '#F9F871',
        '#F9F1F0', '#FEFAE5', '#FCFAF0', '#322D2F', '#05445E', '#2F5233', '#53565A', '#116530', '#4A5977', '#870DD9', '#636059', '#2C65BA',
        '#0064D2', '#75668F', '#8461BA', '#C85250', '#A664B5', '#E43D40', '#A7729A', '#82858E', '#F2059F',
        '#0785F2', '#F24150', '#FC2E20', '#4889DE', '#008FD7', '#189AB4', '#E7625F', '#05A63A', '#18A558',
        '#F85C70', '#A483E3', '#8D9797', '#00A79B', '#F26E22', '#D57F96', '#00AD7D', '#F37970', '#00AAEA',
        '#FD7F20', '#21B6A8', '#00B3D0', '#76B947', '#F79489', '#B5B2B0', '#00C7E2', '#AEB8C4', '#94C973',
         '#59D7EE', '#C0C9CC', '#C0C9D0', '#C1C8D9', '#7DD4F7', '#53DFD1',
        '#C4CEC5', '#F7BEC0', '#CBCDCB', '#FABEC0', '#B1D8B7', '#FFBDEE', '#66E8C1', '#75E6DA', '#88EA85',
        '#9DE3F6', '#CCDCDB', '#A6E8BB', '#84F0AD', '#A3EBB1', '#E3D9E0', '#A8F597', '#FADCD9', '#A1F7A1',
        '#E5E8E8', '#E9EAE0', '#CFF882',

      ]
    }
  ];



  @ViewChild('reportOverview') pdfReport: ElementRef;


  viewMonth: boolean = true;
  responseTendineInventory: any = {};
  destroy$ = new Subject<boolean>();


  constructor(private reportingService: ReportingService, private networkService: NetworkService,
    private toastr: ToastrManager,
    private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    if (!this.reportingService.overviewLoadedAlmostOneTime) {
      this.initTendineValue();
    } else {
      this.selectedItemsYear = this.reportingService.selectedItemsOverview.selectedItemsYear;
      this.selectedItemsMonth = this.reportingService.selectedItemsOverview.selectedItemsMonth;
      this.selectedItemsCountry = this.reportingService.selectedItemsOverview.selectedItemsCountry;
      this.selectedItemsCustomer = this.reportingService.selectedItemsOverview.selectedItemsCustomer;
      this.selectedItemsOrderType = this.reportingService.selectedItemsOverview.selectedItemsOrderType;
      this.selectedItemsBO = this.reportingService.selectedItemsOverview.selectedItemsBO;
      this.selectedItemsIdGlobal = this.reportingService.selectedItemsOverview.selectedItemsIdGlobal;
      this.selectedItemsLead = this.reportingService.selectedItemsOverview.selectedItemsLead;
      this.selectedItemsOrderStatus = this.reportingService.selectedItemsOverview.selectedItemsOrderStatus;
      this.selectedItemsOrderCluster = this.reportingService.selectedItemsOverview.selectedItemsOrderCluster;
      this.orders = this.reportingService.ordersOverview;
      this.pieChartData = this.reportingService.pieChartDataOverview;
      this.pieChartLabels = this.reportingService.pieChartLabelsOverview;
    }
  }


  initTendineValue() {
    this.initOrderCluster();
    this.initBO();
    this.initCountry();
    this.initCustomer();
    this.initMonth();
    this.initYear();
    this.initOrderType();
    this.initOrderStatus();
    this.initLead();
    this.initReport();
  }

  initOrderCluster() {
    let arrayOrderCluster: any[] = [];
    if (this.dropdownListOrderCluster && this.dropdownListOrderCluster.length > 0) {
      for (let elem of this.dropdownListOrderCluster) {
        arrayOrderCluster.push(elem);
      }
    }
    this.selectedItemsOrderCluster = arrayOrderCluster;
  }

  initBO() {
    let arrayBO: any[] = [];
    if (this.dropdownListBO && this.dropdownListBO.length > 0) {
      for (let elem of this.dropdownListBO) {
        arrayBO.push(elem);
      }
    }
    this.selectedItemsBO = arrayBO;
  }

  initCountry() {
    let arrayCountry: any[] = [];
    if (this.dropdownListCountry && this.dropdownListCountry.length > 0) {
      for (let elem of this.dropdownListCountry) {
        arrayCountry.push(elem);
      }
    }
    this.selectedItemsCountry = arrayCountry;
  }

  initCustomer() {
    let arrayCustomer: any[] = [];
    if (this.dropdownListCustomer && this.dropdownListCustomer.length > 0) {
      for (let elem of this.dropdownListCustomer) {
        arrayCustomer.push(elem);
      }
    }
    this.selectedItemsCustomer = arrayCustomer;
    this.initCustomerIdGlobal();
  }

  initMonth() {
    let arrayMonth: any[] = [];
    if (this.dropdownListMonth && this.dropdownListMonth.length > 0) {
      for (let elem of this.dropdownListMonth) {
        arrayMonth.push(elem);
      }
    }
    this.selectedItemsMonth = arrayMonth;
  }

  initYear() {
    let arrayYear: any[] = [];
    if (this.dropdownListYear && this.dropdownListYear.length > 0) {
      for (let elem of this.dropdownListYear) {
        if (elem.item_id == this.getCurrentYear()) {
          arrayYear.push(elem);
        }
      }
    }
    this.selectedItemsYear = arrayYear;
  }

  initOrderType() {
    let arrayOrderType: any[] = [];
    if (this.dropdownListOrderType && this.dropdownListOrderType.length > 0) {
      for (let elem of this.dropdownListOrderType) {
        arrayOrderType.push(elem);
      }
    }
    this.selectedItemsOrderType = arrayOrderType;
  }

  loadReport(data: any) {
    this.loadReportEvent.emit(data);
  }

  getSumOrders() {
    let sum = 0;
    if (this.orders && this.orders.length > 0) {
      for (let elem of this.orders) {
        sum = +sum + +elem.tot;
      }
    }
    return sum;
  }

  initReport() {
    let data: any = {
      selectedItemsYear: this.selectedItemsYear,
      selectedItemsMonth: this.selectedItemsMonth,
      selectedItemsCountry: this.selectedItemsCountry,
      selectedItemsCustomer: this.selectedItemsCustomer,
      selectedItemsOrderType: this.selectedItemsOrderType,
      selectedItemsBO: this.selectedItemsBO,
      selectedItemsIdGlobal: this.selectedItemsIdGlobal,
      selectedItemsLead: this.selectedItemsLead,
      selectedItemsOrderStatus: this.selectedItemsOrderStatus,
      selectedItemsOrderCluster: this.selectedItemsOrderCluster
    }
    this.reportingService.setSelectedItemsOverview(data);

    this.loadReportEvent.emit(data);
  }

  initCustomerIdGlobal() {
    let arrayIdGlobal: any[] = [];
    if (this.selectedItemsCustomer && this.selectedItemsCustomer.length > 0) {
      for (let elem of this.selectedItemsCustomer) {
        let key: string = elem.item_id;
        if (this.idLeadGlobalOfCustomerName) {
          let arrayIds = this.idLeadGlobalOfCustomerName.get(key);
          if (Array.isArray(arrayIds)) {
            for (let globalId of arrayIds) {
              let data: any = {
                item_id: globalId,
                item_text: globalId
              }
              let cust = arrayIdGlobal.find(x => x.item_id == data.item_id);
              if (!cust) {
                arrayIdGlobal.push(data);
              }

            }
          }
        }
      }
    }
    this.selectedItemsIdGlobal = arrayIdGlobal;
  }

  initOrderStatus() {
    let arrayOrderStatus: any[] = [];
    if (this.dropdownListOrderStatus && this.dropdownListOrderStatus.length > 0) {
      for (let elem of this.dropdownListOrderStatus) {
        arrayOrderStatus.push(elem);
      }
    }
    this.selectedItemsOrderStatus = arrayOrderStatus;
  }

  initLead() {
    let arrayLead: any[] = [];
    if (this.dropdownListLead && this.dropdownListLead.length > 0) {
      for (let elem of this.dropdownListLead) {
        arrayLead.push(elem);
      }
    }
    this.selectedItemsLead = arrayLead;
  }

  updateFilterEvent(event: any) {
    this.selectedItemsYear = event.selectedItemsYear;
    this.selectedItemsMonth = event.selectedItemsMonth;
    this.selectedItemsCountry = event.selectedItemsCountry;
    this.selectedItemsCustomer = event.selectedItemsCustomer;
    this.selectedItemsOrderType = event.selectedItemsOrderType;
    this.selectedItemsBO = event.selectedItemsBO;
    this.selectedItemsIdGlobal = event.selectedItemsIdGlobal;
    this.selectedItemsLead = event.selectedItemsLead;
    this.selectedItemsOrderStatus = event.selectedItemsOrderStatus;
    this.selectedItemsOrderCluster = event.selectedItemsOrderCluster;
    this.reportingService.setChangedFilterOverview();
    this.reportingService.setSelectedItemsOverview(event);
  }

  htmltoPDF() {
    // printDiv is the html element which has to be converted to PDF
    const pdfTable = this.pdfReport.nativeElement;
    html2canvas(pdfTable).then(canvas => {
      const width = 208;
      var height = canvas.height * width / canvas.width;
      var imgData = canvas.toDataURL('image/png');
      var pdf = new jspdf('l', 'mm', 'a4');
      pdf.setFont('gill-sans-nova');
      let widthImage = pdf.internal.pageSize.getWidth();
      let heightImage = pdf.internal.pageSize.getHeight();
      let cont: number = 15;
      let options: TextOptionsLight = {
        align: 'center'
      };
      pdf.setFontSize(20);
      pdf.text("Orders Volume Report", widthImage/2, cont, options);
      pdf.setFontSize(16);
      let orderClusterString: string = this.createTextBySelectedItems(this.selectedItemsOrderCluster);

      let leadmember: string = this.createTextBySelectedItems(this.selectedItemsLead);

      let customers: string = this.createTextBySelectedItems(this.selectedItemsCustomer);

      let bmember: string = this.createTextBySelectedItems(this.selectedItemsBO);

      let nazioni: string = this.createTextBySelectedItems(this.selectedItemsCountry);

      let years: string = this.createTextBySelectedItems(this.selectedItemsYear);

      let mesi: string = this.createTextBySelectedItems(this.selectedItemsMonth);

      let tipi: string = this.createTextBySelectedItems(this.selectedItemsOrderType);

      let orderStatus: string = this.createTextBySelectedItems(this.selectedItemsOrderStatus);

      pdf.addImage(imgData, 'PNG', 2, heightImage/4, widthImage-6, height+20);
      pdf.addPage();

      pdf.text("Orders Volume Filters", widthImage/2, cont, options);

      let styles: Partial<Styles> = {
        font: 'gill-sans-nova'
      };

      autoTable(pdf, {
        head: [['FILTER', 'VALUES']],
        body: [
          ['YEAR', years],
          ['MONTH', mesi],
          ['ORDER CLUSTER', orderClusterString],
          ['LEAD OPERATOR', leadmember],
          ['CUSTOMER', customers],
          ['B OPERATOR', bmember],
          ['COUNTRY', nazioni],
          ['ORDER TYPE', tipi],
          ['ORDER STATUS', orderStatus],
        ],
        startY:  30,
        styles: styles
      });




      pdf.save("OrdersVolumeReport.pdf");

    });

  }



  viexExportPdf() {
    if (this.pieChartData && this.pieChartData.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  createTextBySelectedItems(selectedItem: any[]) {
    let result: string = "";
    if (selectedItem && selectedItem.length > 0) {
      let i: number = 1;
      for (let elem of selectedItem) {

        if (i == selectedItem.length) {
          result = result + (elem.item_text || elem.item_id);
        } else {
          result = result + (elem.item_text || elem.item_id) + " , "
        }
        i++;

      }

    }
    return result;
  }



  getCurrentYear(): string {
    const currentYear = new Date().getFullYear();
    return String(currentYear);
  }



  ngAfterViewInit(): void {

    this.pdfReport.nativeElement.focus();

  }

  viewCards() {
    let result: boolean = this.orders && this.orders.length > 0;
    return result;
  }

  getSumCompleted() {
    let sum = 0;
    if (this.orders && this.orders.length > 0) {
      for (let elem of this.orders) {
        if (elem.status == "COMPLETED") {
          return elem.tot;
        }
      }
    }
    return sum;
  }

  getSumFailed() {
    let sum = 0;
    if (this.orders && this.orders.length > 0) {
      for (let elem of this.orders) {
        if (elem.status == "FAILED") {
          return elem.tot;
        }
      }
    }
    return sum;
  }

  getSumProgress() {
    let sum = 0;
    if (this.orders && this.orders.length > 0) {
      for (let elem of this.orders) {
        if (elem.status == "INPROGRESS") {
          return elem.tot;
        }
      }
    }
    return sum;
  }

  initializeTendine() {

    this.spinner.show("sp1");
    let urlTendineReporting: string = environment.basePath + _ENDPOINT.getTendineReporting;
    let data = {
      body: ''
    }
    this.networkService.post(urlTendineReporting, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {
        if (this.networkService.checkEnvironmentIsDev()) {
          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            this.responseTendineInventory = JSON.parse(response.body);
            this.initTendineCountryAndCustomer(this.responseTendineInventory);
            this.initTendine(this.responseTendineInventory);
            this.spinner.hide("sp1");

          } else if (response && response.statusCode == '500' && response.body && response.body.length > 0) {
            this.spinner.hide('sp1');
            this.toastr.errorToastr(response.body, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        } else {
          if (response && response.customerOfCountry) {
            this.responseTendineInventory = response;
            this.initTendineCountryAndCustomer(this.responseTendineInventory);
            this.initTendine(this.responseTendineInventory);
            this.spinner.hide("sp1");
          } else if (response && response.length && response.length > 0) {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          } else {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr('Error during selectItem reporting Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        }
      },
        err => {
          this.spinner.hide("sp1");
          this.toastr.errorToastr('Error during selectItem reporting Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          console.error(err);
        });
  }

  initTendineCountryAndCustomer(responseTendineInventory: any) {
    if (responseTendineInventory && responseTendineInventory.customerOfCountry
      && responseTendineInventory.orderTypeOfOrderCLuster) {
      this.customerOfCountry = new Map(Object.entries(responseTendineInventory.customerOfCountry));
      this.orderTypeOfOrderCLuster = new Map(Object.entries(responseTendineInventory.orderTypeOfOrderCLuster));
      this.idLeadGlobalOfCustomerName = new Map(Object.entries(responseTendineInventory.idLeadGlobalOfCustomerName));
      this.initDropdownCountryCustomer();
    }
  }

  initDropdownCountryCustomer() {
    let country: any[] = [];
    let customer: any[] = [];
    for (let [key, value] of this.customerOfCountry) {
      let data = { item_id: key, item_text: key };
      if (country.indexOf(data) == -1) {
        country.push(data);
      }
      for (let elem of value) {
        let dataCustomer = { item_id: elem, item_text: elem };
        let cust = customer.find(x => x.item_id == dataCustomer.item_id);
        if (!cust) {
          customer.push(dataCustomer);
        }

      }
    }
    this.dropdownListCountry = country;
    this.dropdownListCustomer = customer;
  }

  initTendine(responseTendineInventory: any) {
    this.dropdownListBO = responseTendineInventory.dropdownListBO;
    this.dropdownListOrderCluster = responseTendineInventory.dropdownListOrderCluster;
    this.dropdownListMonth = responseTendineInventory.dropdownListMonth;
    this.dropdownListYear = responseTendineInventory.dropdownListYear;
    this.dropdownListOrderType = responseTendineInventory.dropdownListOrderType;
    this.dropdownListOrderStatus = responseTendineInventory.dropdownListOrderStatus;
    this.dropdownListLead = responseTendineInventory.dropdownListLead;
    this.initTendineValue();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }


}
